import { render, staticRenderFns } from "./email-invitation.vue?vue&type=template&id=16475031&scoped=true&lang=pug&"
import script from "./email-invitation.vue?vue&type=script&lang=js&"
export * from "./email-invitation.vue?vue&type=script&lang=js&"
import style0 from "./email-invitation.vue?vue&type=style&index=0&id=16475031&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16475031",
  null
  
)

export default component.exports